import { render, staticRenderFns } from "./ReceiptList.vue?vue&type=template&id=a98d4896&scoped=true"
import script from "./ReceiptList.vue?vue&type=script&lang=ts"
export * from "./ReceiptList.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptList.vue?vue&type=style&index=0&id=a98d4896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d4896",
  null
  
)

export default component.exports